import { Box, Stack, Typography } from '@mui/material';
import { ElementType } from 'react';
import { FormattedMessage } from 'react-intl';

import { replacePathParams } from 'utils/routes.utils';
import { aspectRatio, cityCardHover } from 'utils/styles.utils';

import { gradients } from 'constants/gradients.constants';
import { Routes } from 'constants/routes.constants';

import Card from 'components/@common/Card';
import DatoImage from 'components/@common/DatoImage';
import LinkUnstyled from 'components/@common/LinkUnstyled';
import { CityCardType } from 'components/@events/types';

interface Props {
  city: CityCardType;
  titleComponent?: ElementType;
  priority?: boolean;
  onClick?: () => void;
}

const CityCard = ({
  city,
  titleComponent = 'h3',
  priority = false,
  onClick,
}: Props) => {
  const hasEvents = !!city.upcomingEvents;
  return (
    <Card
      component={!!city.upcomingEvents ? LinkUnstyled : undefined}
      href={replacePathParams(Routes.CityDetail, { slug: city.slug })}
      onClick={onClick}
      sx={{
        ...aspectRatio(9, 16),
        ...(hasEvents && cityCardHover),
        ...(!hasEvents && gradients.citiesCardEmpty),
        ...gradients.citiesCard,
      }}
    >
      <DatoImage
        data={city.cover}
        style={{ objectFit: 'cover' }}
        fill
        priority={priority}
        sizes="512px"
      />
      <Box
        position="absolute"
        width="100%"
        height="100%"
        sx={{ ...gradients.citiesCard }}
      />

      <Stack mt="auto" zIndex={1} p={{ xs: 2, md: 3 }}>
        <Typography variant="h5" component={titleComponent} sx={{ mb: 0.5 }}>
          {city.name}
        </Typography>
        <Typography
          variant="extraSmall"
          color={hasEvents ? 'secondary.main' : 'grey.600'}
        >
          {hasEvents ? (
            <FormattedMessage
              id="event.city.upcoming.count"
              values={{ amount: city.upcomingEvents }}
            />
          ) : (
            <FormattedMessage id="event.city.noupcomingevents" />
          )}
        </Typography>
      </Stack>
    </Card>
  );
};

export default CityCard;
